import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-page-menu',
	templateUrl:'./WaPageMenuProPage.html',
	styles: [],
	styleUrls:['./WaPageMenuProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPageMenuProPage
{
	mdContent_404 = `\`\`\`java
import com.jwebmp.webawesome.components.page.WaPageMenu;
\`\`\``;
	mdContent_405 = `\`\`\`java
new WaPageMenu<>()
\`\`\``;
}
